import "./OutputDocuments.scss";

import classNames from "classnames";
import { BsDropdown } from "components/Bootstrap/BsDropdown";
import { OutputDocumentViewModel } from "models/OutputDocumentViewModel";
import { useBoard } from "providers";
import { useOutputDocuments } from "providers";
import { useOutputDocumentsPanel } from "providers";
import { useTranslations } from "providers";
import { useMeeting } from "providers";
import React from "react";

export const OutputDocumentsMeeting: React.FC = () => {
  const i18n = useTranslations();
  const { meetingId } = useMeeting();
  const { isLoading, meetingLinks } = useOutputDocuments();
  const { onSelectDocument } = useOutputDocumentsPanel();
  const { canGenerateDocuments } = useBoard();

  const isEnabled = canGenerateDocuments && !!meetingId;
  if (!isEnabled) {
    return null;
  }

  return (
    <BsDropdown
      name="OutputDocumentsMeeting"
      menuClass="dropdown-with-icon"
      displayValue={i18n.OutputDocuments_Button_Meeting}
      disabled={isLoading}
      items={meetingLinks}
      onClick={(item) => {
        const vm = item as OutputDocumentViewModel;
        if (!vm) return;
        onSelectDocument(vm, meetingId, undefined);
      }}
      renderItem={(item) => {
        const vm = item as OutputDocumentViewModel;
        if (!vm) return null;

        const { description, title, iconClass, disabled, disabledMessage } = vm;

        return (
          <div className="d-flex">
            <div className="icon-start">{iconClass && <i className={classNames(iconClass)} />}</div>

            {description && description != "-" ? (
              <div className="global-tooltip-trigger" title={description}>
                {title}
              </div>
            ) : (
              <div>{title}</div>
            )}

            <div className="icon-end">
              {disabled && disabledMessage && (
                <i
                  className="ms-Icon ms-Icon--StatusCircleBlock global-tooltip-trigger text-danger"
                  title={disabledMessage}
                />
              )}
            </div>
          </div>
        );
      }}
    />
  );
};
